import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({on:{"click":_vm.addToCalendar}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Remind Me")]}),_c('AddToCalendar',{attrs:{"title":_vm.title,"description":_vm.description,"start":_vm.start},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }